import Vue from 'vue'
import App from './client_stages/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const clientStageBuilder = document.getElementById('client-builder');

  if (clientStageBuilder) {
    new Vue({
      el: '#client-builder',
      render: h => h(App)
    }).$mount();
  }
});